import { isEmpty, isNil } from 'lodash'

export const isNotNil = <T>(v: T): v is NonNullable<T> => !isNil(v)
export const isNotEmpty = <T>(v: T) => !isEmpty(v)
